export const DEFAULT_TRANSITION_FUNC_AND_DURATION = "data-[enter]:ease-in data-[enter]:duration-150 data-[leave]:ease-out data-[leave]:duration-200";

export const FAST_LINEAR_TRANSITION = "data-[enter]:duration-100 data-[leave]:duration-300";

export const MENU_AND_DROPDOWN_TRANSITION = "transition ease-out data-[closed]:opacity-0 data-[closed]:scale-90 data-[enter]:duration-100 data-[leave]:duration-150";
